export enum CardBlockReason {
    BlockedCard ,
    LostOrStolenCard,
    BrokenCard
}


// WEBPACK FOOTER //
// ./src/app/models/CardBlockReason.ts